import React from 'react';
import {BrowserRouter as Router,Navigate,Route,Routes} from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import DebugPanel from './components/DebugPanel';
import QuizTrustPanel from './components/QuizTrustPanel';
import SpecialtyImageGallery from './components/SpecialtyImageGallery';
import MainHome from './pages/MainHome';
import Weightrx from './pages/Weightrx';
import HairRx from './pages/HairRx';
import MenRx from './pages/MenRx';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Disclaimer from './pages/Disclaimer';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Shipping from './pages/Shipping';
import Refund from './pages/Refund';
import Quiz from './pages/Quiz';
import MenQuiz from './pages/MenQuiz';
import HairQuiz from './pages/HairQuiz';
import WeightCart from './pages/WeightCart';
import HairCart from './pages/HairCart';
import MenCart from './pages/MenCart';
import MyCart from './pages/MyCart';
import MyTreatments from './pages/MyTreatments';
import AdminDashboard from './pages/AdminDashboard';
import {initTracking} from './utils/tracking';

function App() {
  React.useEffect(()=> {
    initTracking();
  },[]);

  return (
    <Router>
      <div className="relative flex min-h-screen flex-col bg-slate-50 text-slate-900 selection:bg-teal-200 selection:text-teal-900">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<MainHome />} />
            <Route path="/weightrx" element={<Weightrx />} />
            <Route path="/hairrx" element={<HairRx />} />
            <Route path="/menrx" element={<MenRx />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/shipping" element={<Shipping />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/weightquiz" element={<Quiz />} />
            <Route path="/quiz" element={<Navigate to="/weightquiz" replace />} />
            <Route path="/menquiz" element={<MenQuiz />} />
            <Route path="/hairquiz" element={<HairQuiz />} />
            <Route path="/weightcart" element={<WeightCart />} />
            <Route path="/haircart" element={<HairCart />} />
            <Route path="/mencart" element={<MenCart />} />
            <Route path="/mycart" element={<MyCart />} />
            <Route path="/mytreatments" element={<MyTreatments />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </main>
        <SpecialtyImageGallery />
        <Footer />
        <DebugPanel />
        <QuizTrustPanel />
      </div>
    </Router>
  );
}

export default App;